import React from "react";
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { PlacementUtils } from '../../features/placements';
import { PlacementDetailsTableService } from '../../features/placements';
import { Utils } from '../';
import { OmniIconComponent, OmniTooltipNextComponent, OmniDropdownComponent } from './omni-components';
import { CreatePlacementOrPackageService } from '../../features/placements';
import { MediaOpsService, AlertMessagesService } from '../../shared';
import { CreateCreativeService } from '../../features/creatives';
import { trackEvent } from "../";
export class InlineEditDialogBox extends React.Component {
    defaultState = {
        selectedRowData: {},
        displayInlineEditModal: false,
        taxonomyMap : {} ,
        allTaxonomyData :{},
        isValueChanged: false,
        syntheticId:'',
        taxonomySchemaArray:'',
        childPlacmentsArray: [],
        taxonomyKeys:{},
        isOverride: false, 
    };
    selectedPlacementForNameEdit = {
        placementId: '',
        nameIndex: -1,
    }
    selectedDDValue = { }
    supplierValues = {}
    constructor(props) {
        super(props);
        this.state ={ ...this.defaultState,
            selectedRowData: {...props.selectedRowData},
            displayInlineEditModal: props.displayInlineEditModal,
            taxonomyMap :props.taxonomyMap ,
            allTaxonomyData : props.allTaxonomyData,
            systemParametersData : props.systemParametersData,
            campaignObj : props.campaignObj,
            omniProfile : props.omniProfile,
            placementList : [],
            // schemaArr : props?.inLineEditObj?.schemaArr,
            editFormData : props?.editFormData,
            taxonomySchemaArray : props.taxonomySchemaArray,
            childPlacmentsArray : [],
            taxonomyKeys: props.taxonomyKeys,
            syntheticId : props?.taxonomyKeys?.syntheticId,
            isOverride: props.isOverride
        };
    }

    /* On load of the component the taxonomy data & disabled menu items are updated and 
    add event handler for the import functionality */
    componentDidMount() {
        this.selectedPlacementForNameEdit.nameIndex = -1;
        // this.getChildList();
        this.setTaxonomyJson(this.state.editFormData);
    }

    /**
     * Set the taxonomy JSON based on the form data and
     * taxonomy preview data based on the data & taxonomy schema
     * @param {Object} formData - The form data to set the taxonomy JSON from
    */
    setTaxonomyJson = (formData) =>{
        let updatedSchema = this.getSchema();
        let selectedRowData = {...this.state.selectedRowData}
        selectedRowData[this.state.taxonomyKeys.schema] = updatedSchema;

        let taxonomyArray = {...this.state.taxonomySchemaArray};
        taxonomyArray.fields = taxonomyArray?.fields?.filter(item => !item.hidden);

        let taxonomyType = this.state.taxonomyKeys.taxonomyName
        let taxonomySelectedValueJson = selectedRowData?.taxonomy && taxonomyType !== 'parameter_code'? selectedRowData.taxonomy : []; 
        if(!taxonomySelectedValueJson?.length || taxonomyType === 'parameter_code'){
            ({taxonomySelectedValueJson} = PlacementUtils.createNames(formData, taxonomyArray, true));
        }
        let taxonomyPrevName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,taxonomyArray?.fields);
        if(this.state.isOverride){
            taxonomyPrevName = this.state.taxonomyKeys.overrideName ? this.state.taxonomyKeys.overrideName?.split(":|")[0] : selectedRowData[this.state.taxonomyKeys?.taxonomyName];
        }
        let syntheticId = this.state.syntheticId
        if(taxonomyType !== 'parameter_code' && !taxonomyPrevName.includes(':|'+syntheticId)){
            taxonomyPrevName = taxonomyPrevName + ':|' + syntheticId;
        }

        this.setState({taxonomyPrevName, taxonomySelectedValueJson, selectedRowData});
        // return taxonomyName;
    }
    /**
     * FUnction will find all child if editing placement is parent,
     * then store all taxonomy for each placement in Array to futher change in placement.
     */
    // getChildList(){
    //     let taxonomySchemaList = [];
    //     let placementId = this.state.selectedRowData?.id;
    //     let placementList = [];
    //     if(this.state.selectedRowData?.nestedData?.length){
    //         placementList = this.converNestedStuctureIntoArray(this.state.selectedRowData?.nestedData)
    //     }
    //     placementList.forEach(item=>{
    //         let taxonomySchema = this.getPlacementPopupField(item);
    //         taxonomySchemaList.push(taxonomySchema);
    //     });
    //     this.setState({childPlacmentsArray:placementList,taxonomySchemaList:taxonomySchemaList});
    // }

    // converNestedStuctureIntoArray(plasementList){
    //     let childList = [];
    //     plasementList.forEach(item=>{
    //         let nestedData = []
    //         if(item?.nestedData?.length){
    //             nestedData = this.converNestedStuctureIntoArray(item?.nestedData);
    //             childList.push(...nestedData)
    //         }
    //         if(item?.nestedData){
    //             delete item['nestedData'] 
    //         }
    //         childList.push(item);
    //     });
    //     return childList;  
    // }
    
    /**
     * The function `getTaxonomyName` takes a placement object and a row index as input and returns an
     * array of HTML elements representing the placement names for that placement.
     * @param placement - The `placement` parameter is an object that contains information about a
     * placement. It includes properties such as `placement_taxonomy`,
     * `nestedData`, `overriden_placement_taxonomy`, and `package_type`.
     * placement is located. It is used to identify the specific placement within the table.
     * @returns an array of HTML elements representing rows of placement names.
     */
    getTaxonomyName(taxonomyType) { 
        let selectedRowData = this.state.selectedRowData; 
        let taxonomySchemaArray = this.state.taxonomySchemaArray?.fields;
        if (taxonomyType !== 'parameter_code' && !this.state.isOverride) {
            selectedRowData.schema_with_hidden = this.getSchema();
        }else{
            taxonomySchemaArray = taxonomySchemaArray?.filter(val=>!val?.hidden);
        }
       
        //Create placement name in Table and user can edit it by click on any placement name value
        return this.createString(taxonomySchemaArray,selectedRowData,taxonomyType);
    }
    
    /**
     * Creates a string representation of the placement data.
     * @param {Array} taxonomySchemaArray - The taxonomy schema array.
     * @param {Object} selectedRowData - The placement data object.
     * @param {string} taxonomyType - The key for the placement.
     * @returns {Array} An array of HTML elements representing the placement names.
     */
    createString(taxonomySchemaArray,selectedRowData,taxonomyType){
        let editFormData = {};
        taxonomySchemaArray?.forEach(field => {
            let fieldName = field.name || field.alias;
            editFormData[fieldName] = this.state.editFormData[field.name] ? this.state.editFormData[field.name] : (this.state.editFormData[field.alias] ? this.state.editFormData[field.alias] : (field.field_type === 10 ? "{TaxonomyValueID}" : 'NU'));
        });
        let nameArrayList = Object.values(editFormData);
        // let syntheticId = /this.state?.syntheticId;//use synthetic

        // if(taxonomyType !== 'parameter_code'){
        //     nameArrayList.push(':|' + syntheticId);
        // }
        // this.setTaxonomyJson(editFormData);
        
        let rows = nameArrayList.map((item, nameIndex) => {
            const fieldObj = taxonomySchemaArray[nameIndex];
            const validationsData = selectedRowData?.validation?.find((item) => item.fieldid === fieldObj?.id || item.fieldname?.toLowerCase() === fieldObj?.name?.toLowerCase());
            let title = fieldObj?.alias ? fieldObj.alias: fieldObj?.name 
            title = title ||  item;
            
            let placementNameDisabled = 'placement-name';
            // condition to check if the placement name is disabled
            let isEditDisabled = fieldObj?.field_type === 9 || fieldObj?.field_type === 10 || fieldObj?.field_type === 3; 
            // || nameArrayList[nameIndex].includes(syntheticId);
            //popupParams is used to pass the parameters to the popup
            let popupParams = [nameIndex, selectedRowData,nameArrayList,fieldObj?.delimiterValue];
            if(taxonomyType == 'parameter_code'){
                isEditDisabled = isEditDisabled || PlacementDetailsTableService.isEditableInlineParameterCode(title,selectedRowData);
            }
            //if placement name is disabled then it will add class placement-name-disabled
            if(isEditDisabled || ['invalid field order', 'invalid fields'].includes(validationsData?.result?.toLowerCase())) {
                // title = syntheticId === nameArrayList[nameIndex] ? title?.split(':|')[1] : title;
                placementNameDisabled = 'placement-name-disabled';
            }
            let delimeter = fieldObj?.delimiterValue || fieldObj?.delimiter_value;
            //if placement name is disabled then it will not add delimeter
            if((nameArrayList?.length === nameIndex+1) || (taxonomyType === 'parameter_code' && nameArrayList?.length === nameIndex+1)){
                delimeter = '';
            }
            let fieldNameError = '';
            //if placement name is disabled then it will add error-color class
            if(validationsData){
                fieldNameError = 'error-color';
            }
            let nameClick = undefined;
            //if placement name is disabled then it will not add click event
            if(!isEditDisabled){
                nameClick = (event) =>  placementNameDisabled === 'placement-name-disabled' ? {} : this.onNameClick(event, nameIndex, selectedRowData, taxonomyType, 0, popupParams);
            }
            let id = `placement=${selectedRowData.id}-${nameIndex}-${taxonomyType}`
            return this.createSpanElementForName(nameArrayList,selectedRowData,id,isEditDisabled,placementNameDisabled,fieldNameError,nameClick,fieldObj,title,delimeter,nameIndex, validationsData);
        });
        return rows;
    }

    createSpanElementForName(nameArrayList,placement,id,isEditDisabled,placementNameDisabled,fieldNameError,nameClick,fieldObj,title, delimeter,nameIndex, validationsData){
        // update field name to taxonomy defined case
        let updatedName = nameArrayList[nameIndex];
        if(!fieldObj?.mandatory && !updatedName){
            updatedName = title;
        }
        const isOption = fieldObj?.mandatory ?  '' : '*';
        return (<span key={id} className="placement-name" id={id}>
            {!isEditDisabled ?  <OmniTooltipNextComponent>
                 <span slot="invoker" part={placementNameDisabled + fieldNameError} className="placement dropdown" onClick={(event) => nameClick(event)}>
                 <span>{fieldObj?.hidden ? '(' : isOption}</span>
                     <span className={isOption? 'optional-field': 'text-value'} part={'wordBreakn headerText'}>
                         {fieldObj?.field_type === 5 ? Utils.parseDateToFormat(updatedName, fieldObj?.dateFormat) : updatedName}
                     </span>
                 </span>
                 <span>{fieldObj?.hidden ? ')' : ''}</span>
                 <div slot="content">{(!isEditDisabled && !placement?.is_ad_row) ? (validationsData ? validationsData.hoverdetails : title) : null}</div>
             </OmniTooltipNextComponent>  
             :
            <OmniTooltipNextComponent>
                <span slot="invoker" part={placementNameDisabled + fieldNameError} className="placement-name-disabled">
                    <span className="text-value" part="wordBreak headerText">
                        {fieldObj?.field_type === 5 ? Utils.parseDateToFormat(updatedName, fieldObj?.dateFormat) : updatedName}
                    </span>
                </span>
                 <div slot="content">{(!isEditDisabled) ? validationsData?.hoverdetails  : title}</div>
            </OmniTooltipNextComponent>
         }{delimeter}

         
     </span>)
    }
    /**
     * The below function will return the schema for the placement based on the package type.
     * It will fetch the taxonomy data for the placement and return the schema.
     * @param {Object} placement - The placement object for which the schema is to be fetched.
     * @param {Boolean} isHidden - The flag to check if the hidden fields are to be included in the schema.
     * @returns {String} - The schema for the placement.
    */
    getSchema = () =>{
        let taxonomyData = this.state.taxonomySchemaArray?.fields
        // let taxonomyData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.state.taxonomyMap, this.state.allTaxonomyData);
        let placementSchemaArr = taxonomyData?.length && taxonomyData?.map(field=> field.name || field.alias)
        // taxonomyData && taxonomyData.fields.forEach((field, index) => {
        //     let fieldName = field.name || field.alias;
        //     if(isHidden){
        //         placementSchemaArr.push(field.name);
        //     }
        //     else if(!isHidden && !field.hidden){
        //         placementSchemaArr.push(field.name);
        //     }  
        // })
        return placementSchemaArr?.join('|');
    }

    /**
    * This function returns the edit placement taxonomy schema data based on the placement type.
    * @param placement - The placement parameter is used to get the package type of the placement.
    * @param taxonomyType - The taxonomyType parameter is used to check if package type is "Child" or not.
    * @returns {array} - edit placement taxonomy schema array
    */
    getPlacementPopupField(placement) {
        let editPackageData= {};
        let taxonomyType= this.state.taxonomyKeys.taxonomyName;
        if(taxonomyType === 'placement_taxonomy'){
            editPackageData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type),this.state.taxonomyMap, this.state.allTaxonomyData);
            // editPackageData = taxonomyData ? PlacementUtils.mapDropdownValues(taxonomyData) : [];
        }else{
            editPackageData = PlacementUtils.mapDropdownValues(this.state.allTaxonomyData.defaultTaxonomyData);
        }
        return editPackageData;
    }

    onNameClick(event, nameIndex, placement,nameType, parameterNameArrLength = 0, popupParams) {
        // Commenting it as this field is not in use currently
        // if(placement.export_status === "Accepted"){
        //     return
        // }
        
        // Check for the popup element in the DOM, if it is not present then create it and append it to the DOM
        let ele = document.getElementById(`popup-${placement.id}-${nameIndex}-${nameType}`);
        if(ele){
            ele.remove();
            ele = null
        }
        
        if(!ele){
            let poupElm = '';
            
            poupElm = this.taxonomyFieldPopup(popupParams[0], popupParams[1], popupParams[2],popupParams[3]);
            
            if(poupElm){
                let clickElem = document.getElementById(`placement=${placement.id}-${nameIndex}-${nameType}`);
                let popupDiv = document.createElement('div');
                // Create a root for the popup element and render the popup element as sibling to the clicked element
                let root = createRoot(popupDiv);
                flushSync(() => {
                    root.render(poupElm);
                });
                clickElem?.insertAdjacentElement('beforeend', popupDiv);
            }
        }
        if ((this.selectedPlacementForNameEdit.nameIndex > -1 && placement.id === this.selectedPlacementForNameEdit.placementId) ||
        (this.selectedPlacementForNameEdit.placementId && placement.id !== this.selectedPlacementForNameEdit.placementId)) {
            let ele = document.getElementById(`popup-${this.selectedPlacementForNameEdit.placementId}-${this.selectedPlacementForNameEdit.nameIndex}-${nameType}`);
            ele && ele.setAttribute('class', 'dropdown-container');
        }

        setTimeout(() => {
            this.selectedPlacementForNameEdit.nameIndex = nameIndex;
            this.selectedPlacementForNameEdit.placementId = placement.id;
            let clickElem = document.getElementById(`placement=${placement.id}-${nameIndex}-${nameType}`);
            let ele = document.getElementById(`popup-${placement.id}-${nameIndex}-${nameType}`);
           
            /**
             * Checks if the element `ele` exists and sets its attribute to make a dropdown active.
             * Depending on the `nameType`, it adjusts the position of the element.
             * If `nameType` is 'parameter_code', it calculates the position based on the right boundary of the element,
             * the left offset of a clicked element (`clickElem`), and the width of both elements to ensure it does not overlap
             * with the 'placement-inline-edit' element on the right. Otherwise, it simply aligns the left of the element with `clickElem`.
             * If `clickElem` is not present, it clears the position.
             * 
             * @param {HTMLElement} ele - The element to be modified.
             * @param {string} nameType - The type of name, affects positioning logic.
             * @param {HTMLElement} clickElem - The element that was clicked, used for positioning reference.
             */
            if(ele){
                ele.setAttribute('class', 'dropdown-container is-active');
                let targetRect = clickElem.getBoundingClientRect();
                if (nameType === 'parameter_code') {
                    // if((ele.getBoundingClientRect().right >= document.getElementById('placement-inline-edit').offsetLeft) && clickElem){
                    //     ele.style.left = (clickElem.offsetLeft - ele.getBoundingClientRect().width) + clickElem.getBoundingClientRect().width + 'px';
                    // }
                } else {
                }
                ele.style.left = targetRect? targetRect.left + 'px' : '';
                ele.style.marginTop = '-90px'
                
                const eleRect = document.getElementById('placement-inline-edit')?.getBoundingClientRect();
                // const targetRect = clickElem.getBoundingClientRect();
     
                // Calculate the bottom position and move the dropdown to top for last 4 records
                const bottomPos = eleRect.bottom - targetRect.bottom;
                if(bottomPos < (ele.offsetHeight + 120)){
                    // ele.style.marginTop  = `-${ele.offsetHeight - clickElem.parentElement.offsetHeight}px`
                }
    
                // position the dropdown
                let dd = ele && ele.querySelectorAll('om2-dropdown-impl') && ele.querySelectorAll('om2-dropdown-impl').length > 0 && ele.querySelectorAll('om2-dropdown-impl')[0].shadowRoot.querySelectorAll('.dropdown-content');
    
                dd && dd.forEach(ele => {
                    if (ele) {
                        ele.style.position = 'initial';
                    }
                });
            }
            event.stopPropagation();
        });
    }

    /**
     * placementEditpopup function generates an HTML template for an edit popup to modify placement data for a specific index and row in a dropdown or input field.
     * @param {number} index - The index of the field within the placement data.
     * @param {Object} selectedRowData - The placement data object.
     * @param {string} placementSchema - The key containing the placement schema.
     * @param {string} placementDisplay - The key containing the display value for the placement.
     * @returns {string} - An HTML template representing the edit popup for the placement.
     */
    taxonomyFieldPopup(index, selectedRowData,PlacementNameArr,delimiterValue) {
        let ddValue =  PlacementNameArr.length?PlacementNameArr[index]:'';
        let fieldName ='';
        let schemaArr = [];
        let schema = this.state.taxonomyKeys.schema;
        const taxonomyType = this.state.taxonomyKeys.taxonomyName;
        if(taxonomyType === 'placement_taxonomy' && selectedRowData?.schema_with_hidden){
            schema = 'schema_with_hidden';
        }
        
        fieldName =  selectedRowData[schema] ? selectedRowData[schema].split('|')[index]:'';
        schemaArr =  selectedRowData[schema] ? selectedRowData[schema].split('|') : [];

        if(!fieldName){
            return ``;
        }
       
        if (ddValue.includes(':|')) {
            ddValue = ddValue.split(':|')[0];
        }

        // Get the package type from the placement object.
        let packageType = selectedRowData.package_type;
        if(selectedRowData.package_type === "Child" && (selectedRowData.parent_type && selectedRowData.parent_type === "Package")){
            packageType = "Child Placement";
        }
        const defaultTaxonomy = this.state?.allTaxonomyData?.defaultTaxonomyData
        let {ddValues,validOptions, field, parentField} = PlacementUtils.getDropdownValues(fieldName,taxonomyType,schemaArr,PlacementNameArr, selectedRowData, this.state.taxonomySchemaArray,defaultTaxonomy,true);

        if(field?.field_type === 9){
            return ``;
        }
        let applyButtonId = `edit-aply-btn-${selectedRowData.id}-${index}-${taxonomyType}`;
        const dropdownId = `popup-${selectedRowData.id}-${index}-${taxonomyType}`;
        const validationPattern = /^\d{1,5}\s?x\s?\d{1,5}(?:\s?-\s?[^ ].{0,19})?$/;
        let res = (
            <div part="dropdown" style={{ width: '349px' }} className="dropdown-container" id={dropdownId} >
                <div part="dropdown-menu" className="dropdown-menu1" role="menu">
                    <div part="dropdown-content" className="dropdown-content" style={{ display: 'flex', flexDirection: 'column' }}>
                        <section part="dropdown-header" className="dropdown-header">
                            {fieldName === 'Dimensions'
                                ? (<div className="object-title" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>{fieldName}
                                    <OmniTooltipNextComponent>
                                        <OmniIconComponent slot="invoker" className="is-size-4" icon-id="omni:informative:info"></OmniIconComponent>
                                        <div slot="content">Correct dimension format example: 100 x 100 - Demo Text 1</div>
                                    </OmniTooltipNextComponent>
                                </div>)
                                : field?.field_type === 2 && field?.allowed_space === false
                                ? (<div className="object-title" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>{fieldName}
                                    <OmniTooltipNextComponent>
                                        <OmniIconComponent slot="invoker" className="is-size-4" icon-id="omni:informative:info"></OmniIconComponent>
                                        <div slot="content">{fieldName}. Spaces are not allowed</div>
                                    </OmniTooltipNextComponent>
                                </div>)
                                : (<span className="object-title">{fieldName}</span>)
                            }
                        </section>
                        <span className="header-border"></span>
                        <section part="dropdown-section" className="dropdown-item">
                            <div part="dropdown-item" style={{ margin: '24px 16px' }}>
                                {(!ddValues || ddValues?.length === 0) ? field?.field_type === 5 ? (<div className="full-width">
                                    <input part="input-control" type="date" className="input text"
                                        data-date={Utils.parseDateToFormat(ddValue, field?.dateFormat)}
                                        value={ddValue}
                                        placeholder={field?.dateFormat}
                                        onChange={this.onInputChange.bind(this, selectedRowData, fieldName, applyButtonId, delimiterValue, field, dropdownId, index,false,PlacementNameArr)}></input>
                                </div>) :
                                    (<div className="full-width">
                                        <input part="input-control" type="text" className="input text is-small"
                                            defaultValue={ddValue}
                                            onChange={this.onInputChange.bind(this, selectedRowData, fieldName, applyButtonId, delimiterValue, field, dropdownId, index,false,PlacementNameArr)}></input>
                                    </div>)
                                    : (<div className="input-container">
                                        {fieldName === 'Dimensions' || fieldName === 'Dimension/Positions' ?
                                            (
                                                <>
                                                    <OmniDropdownComponent
                                                        key={fieldName + index}
                                                        style={{width: '100%'}}
                                                        typeahead
                                                        searchindropdown
                                                        dynamicadditions
                                                        value={PlacementUtils.getDropDownValue(fieldName, this.selectedDDValue, validOptions, ddValue)}
                                                        options={validOptions}
                                                        hidefooter={true}
                                                        onDropdownChange={(event) => this.handleDimensionsChange(event, fieldName, selectedRowData, applyButtonId, ddValue, ddValues, delimiterValue, validOptions, validationPattern, dropdownId, index,false,PlacementNameArr)}
                                                    ></OmniDropdownComponent>
                                                    {!validOptions?.length && parentField && <span part="error-helper-text">This field is explicitly mapped with {parentField.name}, hence no value is mapped to the selected parent value</span>}
                                                </>)
                                            : (
                                                <>
                                                    <OmniDropdownComponent
                                                        typeahead
                                                        style={{width: '100%'}}
                                                        searchindropdown
                                                        key={fieldName + index }
                                                        value={PlacementUtils.getDropDownValue(fieldName, this.selectedDDValue, validOptions, ddValue)}
                                                        options={validOptions}
                                                        hidefooter={true}
                                                        onDropdownClick={() => this.handleDropDownClick(selectedRowData, index, taxonomyType)}
                                                        onDropdownChange={(e) => this.onDropDownChange(e.detail?.id, selectedRowData, applyButtonId, ddValues, fieldName, delimiterValue, index,false,PlacementNameArr)}
                                                    ></OmniDropdownComponent>
                                                    {!validOptions?.length && parentField && <span part="error-helper-text">This field is explicitly mapped with {parentField.name}, hence no value is mapped to the selected parent value</span>}
                                                </>)
                                        }
                                    </div>)
                                }

                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                <button className="tertiary" part="placement-name-cancel-button" onClick={(e) => this.onCancelField(index, selectedRowData, applyButtonId, taxonomyType)} >Close</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>);
        return res;
    }

    /** 
    * Description; to change the input value from dropdown
    * if condition will not enable apply btn till text box have value
    * @param {any} placement
    * @param {any} fieldName
    * @param {any} applyButtonId
    * @param {any} event
    * @returns {any}
    */
    onInputChange = (placement, fieldName, applyButtonId, delimiterValue, field, dropdownId, nameIndex,duplicate,PlacementNameArr, event) => {
        const updatedValue = event.target.value;
        
        // Check for space validation using helper method
        if (!this.validateFieldSpaces(updatedValue, fieldName, placement)) {
            AlertMessagesService.showWarningToastMessage(`Spaces are not allowed in ${fieldName}`);
            // Clear the input value to prevent invalid input
            event.target.value = updatedValue.replace(/\s+/g, '');
            return;
        }
        
        // Get the apply button element
        const applyButton = document.getElementById(applyButtonId);
        
        if(updatedValue){
             ///Check Split why using updatedValue value
            const processedValue = delimiterValue ? updatedValue.split(delimiterValue)[0] : updatedValue;
            this.selectedDDValue = {"value": processedValue, "name": fieldName};
            if(field?.field_type === 5){
                let datePopupInput = document.getElementById(dropdownId).querySelector('input');
                datePopupInput.setAttribute('data-date', Utils.parseDateToFormat(updatedValue, field.dateFormat));
            }
             // Auto-apply the changes immediately
            this.onChangeValue(nameIndex, duplicate, placement,applyButtonId,true);
        }else{
            this.selectedDDValue = null;
        }
    }

    /**
     * Handle a click event for dimensions in a table and show the related dropdown.
     * @param {string} placement - The placement for which the click event is triggered.
     * @param {number} index - The index of the element within the row.
     * @param {string} taxonomyType - The unique key associated with the placement.
     */
    handleDropDownClick = (placement, index, taxonomyType) => {
        let ele = document.getElementById(`popup-${placement.id}-${index}-${taxonomyType}`)?.querySelector('omni-dropdown')?.shadowRoot.querySelector('.dropdown');
        ele && ele.setAttribute('part', 'dropdown is-active');
    }
    
    /**
     * Handle a change in dimensions or dropdown value and trigger related actions.
     * The function is designed to respond to changes in either dimensions or dropdown values. 
     * When such changes occur, it initiates a series of actions that are closely related to the specific context in which the change occurs.
     * @param {Event | { value: string, detail: string }} event - The event object or a value to handle.
     * @param {string} fieldName - The name of the field being updated.
     * @param {string} placement - The placement related to the change.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {string} ddValue - The selected dropdown value.
     * @param {Array<{ id: string, label: string, value: string }>} ddValues - Available dropdown values.
     * @param {Array<{ value: string }>} validOptions - Valid options for the dropdown.
     * @param {RegExp} validationPattern - Regular expression for validation.
     */
    handleDimensionsChange = (event, fieldName, placement, applyButtonId, ddValue, ddValues, delimiterValue, validOptions, validationPattern, dropdownId, nameIndex,duplicate,PlacementNameArr) => {
        // Get the new value from the event
        let newEventValue = event.target.value.length ? Utils.getValue(event): '';
        // Determine the current dropdown value
        const dropdownValue = PlacementUtils.getDropDownValue(fieldName,this.selectedDDValue,validOptions,ddValue)
        // Check if the new value is different from the dropdown value
        if((dropdownValue[0]?.id?.trim() !== newEventValue?.trim()) && fieldName === 'Dimensions'){
            newEventValue = newEventValue?.replace(/x/g, " x ")?.replace(/-/g, " - ");
            newEventValue = newEventValue?.replace(/\s+/g, " ");
            this.onDropDownChange(newEventValue, placement, applyButtonId,ddValues,fieldName,delimiterValue, nameIndex,duplicate,PlacementNameArr)
        }else{
            this.onDropDownChange(newEventValue, placement, applyButtonId,ddValues,fieldName,delimiterValue, nameIndex,duplicate,PlacementNameArr)
        }
        if(fieldName === 'Dimensions'){
            if(validationPattern.test(newEventValue.trim())){
                document.getElementById(dropdownId)?.querySelector('omni-dropdown')?.removeAttribute('error')
            }else{
                document.getElementById(dropdownId)?.querySelector('omni-dropdown')?.setAttribute('error', 'Wrong format entry, see info example')
            }
        }
    }
    
    /**
     * Handles the change event of the placement dropdown.
     * This function is responsible for processing the change event that occurs when a user
     * selects a different option in the placement dropdown. It performs several tasks, including
     * updating the selected dropdown value, validating the selected value using a regular expression
     * pattern, and modifying the appearance of the associated apply button based on the validation result.
     * @param {string} updatedValue - The updated value of the dropdown.
     * @param {string} placement - The placement information.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {Array} options - The array of options for the dropdown.
     * @param {string} fieldName - The name of the field associated with the dropdown.
     * @returns {void}
     */

    onDropDownChange = (event, placement, applyButtonId,options,fieldName,delimiterValue, nameIndex, duplicate = false,PlacementNameArr) => {
        const updatedValue = event;
        let selOpt = options.find(obj => obj.id === updatedValue) ? options.find(obj => obj.id === updatedValue) : {id:updatedValue, label: updatedValue, value: updatedValue};
        const validationPattern = /^\d{1,5}\s?x\s?\d{1,5}(?:\s?-\s?[^ ].{0,19})?$/;
        const applyButton = document.getElementById(applyButtonId);
        
        // Check for space validation using helper method
        if (updatedValue && !this.validateFieldSpaces(updatedValue, fieldName, placement)) {
            AlertMessagesService.showWarningToastMessage(`Spaces are not allowed in ${fieldName}`);
            // Disable apply button when validation fails
            if (applyButton) {
                applyButton.setAttribute('class', 'placement-name-apply-button');
                applyButton.disabled = true;
            }
            return;
        }
        
        if(selOpt && selOpt.id){
            ///Check Split why using updatedValue value 
            this.selectedDDValue =  {"value":updatedValue?.split(delimiterValue)[0],"label": selOpt.value, "name":fieldName,"option_id":selOpt.option_id};
            
            if(fieldName === 'Dimensions'){
                if(validationPattern.test(updatedValue.trim())){ 
                    // Auto-apply valid dimensions
                    this.onChangeValue(nameIndex, duplicate, placement,applyButtonId);
                }else{
                    // Don't apply invalid dimensions
                    return;
                }
            } else {
                // Auto-apply for non-dimension fields
                this.onChangeValue(nameIndex, duplicate, placement,applyButtonId);
            }     
        }
    }

    onCancelField = ( nameIndex, placement, applyButtonId,taxonomyType) => {
        this.selectedDDValue = null;
        this.selectedPlacementForNameEdit.nameIndex = -1;
        // Placement Edit Cancel
        let ele = document.getElementById(`popup-${placement.id}-${nameIndex}-${taxonomyType}`);
        if(ele){
            // document.getElementById(applyButtonId)?.setAttribute('class', 'placement-name-apply-button');
            ele && ele.setAttribute('class', 'dropdown-container');
        }
    }

    /**
     * This is triggered when the user clicks on a button to apply changes to a placement name in a table.
     * @param {string}  `nameIndex`
     * @param {array}  `placement`. It first checks if a dropdown value is selected, then sets a spinner to indicate that the changes are being processed.
     * @param {string}  `placementSchema` key string of object in placement
     * @param {string}  `placementDisplay` key string of object in placement
     * @returns It then updates the placement name state based on the selected dropdown value and other placement details.
     */
    onChangeValue = (nameIndex, duplicate = false, placement,applyButtonId,isInputChange = false) => {
        let selectedDDValue = this.selectedDDValue ;
        if(!selectedDDValue) {
            return;
        }
        const schema = this.state.taxonomyKeys.schema
        const taxonomyType = this.state.taxonomyKeys.taxonomyName
        let fieldName = placement[schema].split('|')[nameIndex];
        let packageType = placement.package_type;
        if(placement.package_type === "Child" && (placement.parent_type && placement.parent_type === "Package")){
            packageType = "Child Placement";
        }
        let taxonomySchemaArray = this.state.taxonomySchemaArray;
        let editFormData = this.state.editFormData;
        const updatedPlacement = this.updateNameState(nameIndex, fieldName, placement,taxonomyType,taxonomySchemaArray,selectedDDValue,editFormData);
        // this.updateChildValues(fieldName,taxonomyType,selectedDDValue);

        this.setState({selectedRowData : {...updatedPlacement}});
        if(updatedPlacement["fieldsWithCascaded"]?.length){
            this.onUpdateInvalidFields(nameIndex, updatedPlacement,taxonomyType,applyButtonId);
            return ;
        }
        if(this.isAnyInvalidFields(nameIndex,updatedPlacement,taxonomyType)){
            return;
        }

        const selectedValueObj = this.selectedDDValue;
        this.selectedDDValue = null;
        this.setState({isValueChanged:true,selectedValueObj});
        // Check for the popup element in the DOM, if it is not present then create it and append it to the DOM
        let ele = document.getElementById(`popup-${placement.id}-${nameIndex}-${taxonomyType}`);
        if(ele && !isInputChange){
            ele.remove();
            ele = null
        }
        let mainElement = document.getElementById(`placement-inline-edit`);
        let isChangePending = mainElement?.querySelectorAll(".invalid");
        if(isChangePending?.length){
            this.setState({isValueChanged:false});
        }
    }

    /**
    * The  code is a function called `updatePlacementNameState` updates the state of a placement name based on the selected value from a dropdown menu
    * it will map the package or placement types after checking the filedName
    * @param {string}  `nameIndex`,
    * @param {string}  `fieldName`
    * @param {string}  `taxonomyType` key string of object in placement
    * @param {array}  `selectedDataRow`. It takes in the index of the name to be updated
    * @returns The name of the field, and the selected value from the dropdown menu as input parameters.
    */
    updateNameState = (nameIndex, fieldName, selectedDataRow,taxonomyType,taxonomySchemaArray,selectedDDValue,editFormData) => {
        editFormData[selectedDDValue.name] = selectedDDValue.value;
        // Validate spaces using helper method
        if (selectedDDValue?.value && !this.validateFieldSpaces(selectedDDValue.value, fieldName, selectedDataRow)) {
            AlertMessagesService.showWarningToastMessage(`Spaces are not allowed in ${fieldName}`);
            return selectedDataRow; // Return without updating if validation fails
        }

        // If placement contains overriden_placement_taxonomy, update the overriden_placement_taxonomy and overriden_placement_display_taxonomy
        if(taxonomyType == 'placement_taxonomy' && selectedDataRow.overriden_placement_taxonomy){
            selectedDataRow  = this.updateOverrideTaxonomy(selectedDataRow, taxonomySchemaArray,editFormData);
        }
        selectedDataRow = this.updateInlineValue(selectedDataRow,taxonomySchemaArray,taxonomyType,editFormData);
        // to check either dropdown select(not for text input)
        let fieldsWithCascaded = [];
        if(nameIndex !== null){
            let popEl = document.getElementById(`popup-${selectedDataRow.id}-${nameIndex}-${taxonomyType}`);
            fieldsWithCascaded = this.checkForCascadingFields(selectedDataRow, taxonomyType, fieldName, selectedDDValue, taxonomySchemaArray, popEl);
        }
        
        //Condtion is for parameter code,when we doing inline ,we updating in line updating placement related value too
        //for ex:buy_category inside placement,using regx to make by replacing space and back slash
        if (taxonomyType == 'parameter_code' && selectedDDValue?.name) {
            let parmaeterKey =  selectedDDValue.name.toLowerCase().replaceAll(/[\s\/]/g,'_');
            selectedDataRow[parmaeterKey] = selectedDDValue?.value;
        }
        selectedDataRow["fieldsWithCascaded"] = fieldsWithCascaded;
        return selectedDataRow;
    }

    /**
     * updating Placement Name value
     * @param {objrect} selectedDataRow 
     * @param {object} selectedDDValue 
     * @param {number} nameIndex 
     * @param {Array} taxonomySchemaArray 
     * @param {Array} nameArr 
     * @param {array} schemaArr 
     * @param {string} taxonomyType 
     * @param {string} sytheticId 
     * @returns  update placement object
     */
    updateInlineValue = (selectedDataRow,taxonomySchemaArray,taxonomyType,editFormData) => {
        let { taxonomySelectedValueJson } = PlacementUtils.createNames(editFormData, taxonomySchemaArray, true);
        
        let updatedName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,taxonomySchemaArray?.fields);
        let updatedDispalyName =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',false,taxonomySchemaArray?.fields);
        //let updatedSchema =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'field_name',false,taxonomySchemaArray?.fields);

        if(taxonomyType !== 'parameter_code'){
            const synthecticId = this.state.syntheticId
            updatedName = `${updatedName + ':|' + synthecticId}`
            // just delete field_name, name from taxonomySelectedValueJson before saving in state
            taxonomySelectedValueJson = taxonomySelectedValueJson.map((item) => {
                delete item['field_name'];
                delete item['name'];
            return item;
            });
            selectedDataRow['taxonomy'] = taxonomySelectedValueJson;
        }else if(taxonomyType == 'parameter_code'){
            let name = this.selectedDDValue.name;
            let newValue = this.selectedDDValue.value;
        
            if(name === 'Buy Type'){
                selectedDataRow["placementType"] = newValue; 
                selectedDataRow["placement_type"] = newValue; 
            }else if(name === 'Buy Category'){
                selectedDataRow["buyCategory"] = newValue;
                selectedDataRow["buy_category"] = newValue;
            }else if(name === 'Site'){
                selectedDataRow["provider"] = newValue;
                selectedDataRow["site"] = newValue;
            }else if(name === 'Ad Verification'){
                selectedDataRow['ad_verification'] = newValue;
            }else if(name === 'Ad Server'){
                selectedDataRow['ad_server'] = newValue;
            }else if(name === 'Dimension/Positions'){
                selectedDataRow['dimension_positions'] = newValue;
            }
        }
        const displayName = this.state.taxonomyKeys.displayName;
        //const schema = this.state.taxonomyKeys.schema;
        selectedDataRow[taxonomyType] = updatedName;
        selectedDataRow[displayName] = updatedDispalyName;
        //selectedDataRow[schema] = updatedSchema;
        
        if(!selectedDataRow?.parent_id){
            this.setState({editFormData});
        }
        let taxonomyPrevName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,taxonomySchemaArray?.fields.filter(item => !item.hidden));
        this.setState({taxonomyPrevName : taxonomyPrevName + ":|" + this.state.syntheticId});
        selectedDataRow['taxonomy_client_id'] = taxonomySchemaArray?.clientid,
        selectedDataRow['taxonomy_schema_id'] =  taxonomySchemaArray?.id
        return selectedDataRow;
    }

    /**
     * Function to update the override taxonomy of a placement on inline edit
     * @param {object} selectedDataRow - The placement object
     * @param {string} packageType - The package type
     * @param {object} taxonomyData - The taxonomy data
     * @returns {object} - The updated placement object
     */ 
    updateOverrideTaxonomy = (selectedDataRow,taxonomyData,editFormData) => {
        const { taxonomySelectedValueJson } = PlacementUtils.createNames(editFormData,taxonomyData,true);

        let updatedName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',true, taxonomyData?.fields);
        let updatedDispalyName =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',true,taxonomyData?.fields);
        selectedDataRow['overriden_placement_taxonomy'] = updatedName;
        selectedDataRow['overriden_placement_display_taxonomy'] = updatedDispalyName;
        
        return selectedDataRow;
    }

    /**
     * the below function checks for cascading fields in the placement table inline edit
     * @param {object} placement - The placement object
     * @param {string} taxonomyType - The key indicating the type of placement data, e.g., "placement_taxonomy".
     * @param {string} fieldName - The name of the field being updated.
     * @param {object} selectedDDValue - The selected dropdown value.
     * @param {object} taxonomyData - The taxonomy data object.
     * @param {array} schemaArr - The array of schema values.
     * @param {array} nameArr - The array of name values.
     * @returns {array} - An array of fields with cascaded dropdowns.
    */ 
    checkForCascadingFields = (placement, taxonomyType, fieldName, selectedDDValue, taxonomyData, popEl) => {
        let schemaArr = this.getSchema().split('|');
        let nameArr = Object.values(this.state.editFormData);
        let fieldsWithCascaded = [];
        //Commneted code will use in future for explicit cascading
        if(selectedDDValue.option_id){
            let filedObj = null;
            let filedArrayList = [];
            let otherArrayList = [];
            let otherSchema = [];
            let otherNameArr = [];
            let otherType = '';
            if(taxonomyType === 'parameter_code'){
                filedObj = this.state.allTaxonomyData.defaultTaxonomyData.fields.find(obj => obj.name === fieldName);
                filedArrayList = this.state.allTaxonomyData.defaultTaxonomyData;
                // otherArrayList = taxonomyData;
                // otherSchema = placement['taxonomy_schema']?.split('|');
                // otherNameArr = PlacementDetailsTableService.splitStringIntoArray(placement.placement_taxonomy,PlacementUtils.mapDropdownValues(otherArrayList), ':|');
                // otherType = 'placement_taxonomy';
            }else{
                filedObj = taxonomyData.fields.find(obj => obj.name === fieldName);
                filedArrayList = taxonomyData;
                // otherArrayList = this.state.allTaxonomyData.defaultTaxonomyData;
                // otherSchema = placement['parameter_code_taxonomy_schema']?.split('|');
                // otherNameArr = PlacementDetailsTableService.splitStringIntoArray(placement.parameter_code,PlacementUtils.mapDropdownValues(otherArrayList));
                // otherType = 'parameter_code';
            }

            // Populate the explicit cascading map
            let cascadingMap = {};
            // PlacementUtils.populateExplicitCascadingMap(taxonomyData, cascadingMap);
            // PlacementUtils.populateExplicitCascadingMap(this.state.allTaxonomyData.defaultTaxonomyData, cascadingMap);
            
            let matchedItem = filedObj.fielditems.find(fObj => fObj.id === selectedDDValue.option_id);
            let childItems = matchedItem ? matchedItem.childitems : [];
            if(childItems.length || !childItems.length && cascadingMap[Number(filedObj.id)]){
                let childFieldIArr = [];
                if(childItems.length){
                    childFieldIArr = childItems.map((chObj) => Number(chObj.FieldId));
                } else {
                    childFieldIArr = cascadingMap[Number(filedObj.id)];
                }
                childFieldIArr.map((fId) => {
                    let matched = filedArrayList.fields.find((fObj) =>fObj.id === fId )
                    if((childItems.length && matched) || (!childItems.length && matched?.isExplicitCascading)){
                        let f_name =matched?.name;
                        let f_index = schemaArr.indexOf(f_name);
                        let f_val = nameArr[f_index];
                        let childItemsValues = childItems.filter((chItem) => Number(chItem.FieldId) === fId);
                        let isMatched = childItemsValues.find((chItem) => chItem.Code === f_val);
                        if(!isMatched){
                            fieldsWithCascaded.push({id:matched?.id,name:f_name,nameIndex:f_index,childItems:childItemsValues, type:taxonomyType});
                        } else {
                            if(popEl?.querySelector(`.invalid-selection-${f_index}`)){
                                popEl.querySelector(`.invalid-selection-${f_index}`).remove();
                            }
                        }
                    }

                    // let otherMatched = otherArrayList?.fields.find((fObj) =>fObj.id === fId )
                    // if((childItems.length && otherMatched) || (!childItems.length && otherMatched?.isExplicitCascading)){
                    //     let f_name =otherMatched?.name;
                    //     let f_index = otherSchema.indexOf(f_name);
                    //     let f_val = otherNameArr[f_index];
                    //     let childItemsValues = childItems.filter((chItem) => Number(chItem.FieldId) === fId);
                    //     let isMatched = childItemsValues.find((chItem) => chItem.Code === f_val);
                    //     if(!isMatched){
                    //         fieldsWithCascaded.push({id:otherMatched?.id,name:f_name,nameIndex:f_index,childItems:childItemsValues, type:otherType});
                    //     } else {
                    //         if(popEl?.querySelector(`.invalid-selection-${f_index}`)){
                    //             popEl.querySelector(`.invalid-selection-${f_index}`).remove();
                    //         }
                    //     }
                    // }
                })
            }
        }
        return fieldsWithCascaded;      
    }

    /** 
    * Checks if there are any invalid fields in a table row
    * @param {string}  `nameIndex`,
    * @param {string}  `taxonomyType` key string of object in placement
    * @param {array}  `updatedSelectedRowData`. It then sets a variable `isInvalid` to false and selects a specific cell in the table using `querySelector`.If there is an element with a specific class name in the cell, it removes it.
    * @returns It then sets a variable `isInvalid` to false and selects a specific cell in the table using `querySelector`.If there is an element with a specific class name in the cell, it removes it. 
    */
    isAnyInvalidFields = (nameIndex,updatedSelectedRowData,taxonomyType) =>{
        let isInvalid = false;
            let currentCell  = document.getElementById(`placement=${updatedSelectedRowData.id}-${nameIndex}-${taxonomyType}`);
            if(currentCell?.querySelector(`.invalid-selection-${nameIndex}`)){
                currentCell.querySelector(`.invalid-selection-${nameIndex}`).remove();
            }
            if(currentCell?.querySelector(".invalid")){
                // Scroll to the invalid cell column if it is diffrent from the current column
                if(!currentCell?.getElementsByClassName(`invalid ${taxonomyType}`).length){
                    let invalidEle = currentCell?.querySelector(".invalid");
                    let invalidEleXPos = invalidEle.getBoundingClientRect().x;
                    // document.getElementById('placement-table').shadowRoot.querySelector('.scroll-container').scroll(invalidEleXPos,0);
                }
                isInvalid = true;
            }
            if(isInvalid){
                let ele = document.getElementById(`popup-${updatedSelectedRowData.id}-${nameIndex}-${taxonomyType}`);
                ele?.setAttribute('class', 'dropdown-container');
                this.setState({isValueChanged:false});
            } else {
                // close all open popups
                let OpenPopups = document.getElementById('placement-inline-edit')?.querySelectorAll('[id^="popup-"][part="dropdown is-active"]');
                for(let i=0; i<OpenPopups?.length; i++){
                    OpenPopups[i].setAttribute('class', 'dropdown-container');
                }
            }
        return isInvalid;
    }

    /**
     * onUpdateInvalidFields function updates the placement table with invalid fields and cascaded dropdowns based on the provided data.
     * @param {number} nameIndex - The index of the field name in the placement table.
     * @param {Object} updatedSelectedRowData - The updated placement data object.
     * @param {string} taxonomyType - The key indicating the type of placement data, e.g., "placement_taxonomy".
     * @returns {void}
     */
    onUpdateInvalidFields =  (nameIndex, updatedSelectedRowData,taxonomyType, applyButtonId) =>{
        let ele = document.getElementById(`placement-inline-edit`);

        /* This code is checking if there is an element with class name
        `invalid-selection-` inside the closest `td` element of the `ele` element. If
        such an element exists, it is removed from the DOM using the `remove()` method. */
        if(ele.querySelector(`.invalid-selection-${nameIndex}`)){
            ele.querySelector(`.invalid-selection-${nameIndex}`).remove();
        }
        let fieldsWithCascaded = updatedSelectedRowData["fieldsWithCascaded"];
        fieldsWithCascaded.map((field, index) => {
            let validValues = field.childItems.map(item =>item.Code);
            ele?.querySelector(`span[id='placement=${updatedSelectedRowData.id}-${field.nameIndex}-${field.type}'`)?.click();
            if(!ele?.querySelector(`span[id='placement=${updatedSelectedRowData.id}-${field.nameIndex}-${field.type}'`)?.querySelector(`.invalid-selection-${field.nameIndex}`))
                ele?.querySelector(`span[id='placement=${updatedSelectedRowData.id}-${field.nameIndex}-${field.type}'`)?.insertAdjacentHTML("afterBegin",`<span class="invalid ${field.type} invalid-selection-${field.nameIndex}" style="color:red;font-weight:bold;">[Invalid Selection!]</span>`);
            
            /* This code is checking if the `om2-dropdown` element inside the `cascadePopup` element has
            a property called `originalOptions`. If it doesn't have this property, the code sets the
            `originalOptions` property to the current options of the `om2-dropdown` element. This is
            useful for storing the original options of the dropdown before any changes are made to
            it, so that they can be restored later if needed. */
            setTimeout(() => {
                let cascadePopup = document.getElementById(`popup-${updatedSelectedRowData.id}-${field.nameIndex}-${field.type}`);
                this.onCancelField(nameIndex, updatedSelectedRowData, applyButtonId, taxonomyType);
                this.setState({isValueChanged:false});
                this.checkForCascadingDropdowns(cascadePopup, validValues, field);
            });
        })
    }

    /**
     * checkForCascadingDropdowns function checks for cascading dropdowns in the placement table 
     * and updates them based on the cascading data.
     * @param {Element} cascadePopup - The popup element containing the cascading dropdown.
     * @param {Array<string>} validValues - An array of valid values for the dropdown.
     * @param {Object} field - The field object containing the dropdown data.
     * @returns {void}
    */ 
    checkForCascadingDropdowns = (cascadePopup, validValues, field) => {
        if(cascadePopup?.querySelector('omni-dropdown')){
            if(!cascadePopup.querySelector('omni-dropdown').originalOptions){
                cascadePopup.querySelector('omni-dropdown').originalOptions = cascadePopup.querySelector('omni-dropdown').options;
            }
            let _options = [];
            // Iterate over each option in the originalOptions of the omni-dropdown element within the cascadePopup
            cascadePopup.querySelector('omni-dropdown').originalOptions.map((opt) => {
                    // Check if the current option's value is included in the validValues array
                if(validValues.includes(opt.value)){
                    // If the value is valid, push the option to the _options array
                    _options.push(opt);
                }
            });
            // If no valid options are found,For each child item, 
            //create a new object with id, label, and value properties and push it to the _options array
            if(!_options.length){
                _options.push(...field.childItems.map(item => {return {id: Number(item.Id), label: item.Name, value: item.Code}}));
            }
            cascadePopup.querySelector('omni-dropdown').options = _options;
        } else if(cascadePopup){
            if(!cascadePopup.querySelector('om2-dropdown').originalOptions){
                cascadePopup.querySelector('om2-dropdown').originalOptions = cascadePopup.querySelector('om2-dropdown').options;
            }
            let _options = [];
            // Iterate over each option in the originalOptions of the om2-dropdown element within the cascadePopup
            cascadePopup.querySelector('om2-dropdown').originalOptions.map((opt) => {
                    // Check if the current option's value is included in the validValues array
                if(validValues.includes(opt.value)){
                            // If the value is valid, push the option to the _options array
                    _options.push(opt);
                }
            });
            // If no valid options are found,For each child item, 
            //create a new object with id, label, and value properties and push it to the _options array
            if(!_options.length){
                _options.push(...field.childItems.map(item => {return {id: Number(item.Id), label: item.Name, value: item.Code}}));
            }
            cascadePopup.querySelector('om2-dropdown').options = _options;
        }
    }
    
    /**
     * Method to handle inline edit API call for placement update by calling the updatePlacement API and handling the response.
     * @param {object} updatedSelectedRowData - The updated placement object.
     * @param {object} otherProps - Other properties required for the API call.
     * @param {array} childPlacmentsArray - The array of child placements.
     * @param {object} selectedValueObj - The selected dropdown value object.
     * @param {number} updateCount - The number of child placements updated.
     * @returns {void}
     */
    updatePlacementValues = (updatedSelectedRowData) => {
        this.props.setSpinnerCount(1);
        let payload = CreatePlacementOrPackageService.preparePayloadForPlacmentsUpdate(updatedSelectedRowData,this.state);
        // adding isApproved field to payload if approval is not required
        if(!this.state.systemParametersData?.data?.isApprovalRequired){
            payload.isApproved = true;
        }
        // Set the payload for override taxonomy
        if(this.state.isOverride && this.state.taxonomyKeys.taxonomyName !== 'parameter_code'){
            payload.overridenPlacementTaxonomy = this.state.taxonomyPrevName;
            payload.overridenPlacementDisplayTaxonomy = this.state.taxonomyPrevName?.split(':|')[0];
            payload.placementTaxonomy = this.state.taxonomyPrevName;
            payload.placementTaxonomyDisplay = this.state.taxonomyPrevName?.split(':|')[0];
            payload.taxonomy = null;
            payload.packageType = updatedSelectedRowData.package_type;
            payload.overrideTaxonomy = true;
            payload.taxonomy_client_id = this.state.taxonomySchemaArray?.clientid;
            payload.taxonomy_schema_id = this.state.taxonomySchemaArray?.id;
        } else {
            payload.overrideTaxonomy = false;
        }
        // Update placement taxonomy name to taxonomy defined case
        CreatePlacementOrPackageService.applyTextCaseTransformation(payload,{taxonomyTextcase: this.state.taxonomySchemaArray[0]?.taxonomyTextcase});

        // Update placement API call
        let campaignId = encodeURIComponent(this.state.campaignObj.id);
        MediaOpsService.updatePlacement(campaignId, updatedSelectedRowData.id, payload, this.state?.versionOneApi).then(result => {
            if(result.data.status === 'success'){
                this.onCancel(true);
            } else {
                AlertMessagesService.showErrorToastMessage('Failed to update placement.');
            }
            this.props.setSpinnerCount(0);
        }, (error) => {
            if (error && error.response?.data?.error?.message === "placement name already exists") {
                this.updatePlacementValues(updatedSelectedRowData)
            } else {
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updatePlacementValues(updatedSelectedRowData), title: 'Unable to update the placement name', bodyMsgArr: []}]);
                this.props.setSpinnerCount(0);
            }
        });
    }

    updateCreativeValues = (updatedSelectedRowData) => {
        this.props.setSpinnerCount(1);
        let payload = [{
            "creative_id": updatedSelectedRowData.creative_id,
            "creative_name": this.state.isOverride ? this.state.taxonomyPrevName : updatedSelectedRowData.creative_name,
            "creative_display_name": this.state.isOverride ? this.state.taxonomyPrevName?.split(':|')[0] : updatedSelectedRowData.creative_display_name,
            "taxonomy_schema": updatedSelectedRowData.taxonomy_schema,
            "taxonomy": this.state.isOverride ? null : updatedSelectedRowData.taxonomy,
            "is_override": this.state.isOverride,
            'taxonomy_client_id': this.state.isOverride ? this.state.taxonomySchemaArray?.clientid : updatedSelectedRowData?.taxonomy_client_id,
            'taxonomy_schema_id': this.state.isOverride ? this.state.taxonomySchemaArray?.id : updatedSelectedRowData?.taxonomy_schema_id
        }]
        CreateCreativeService.updateCreative(payload)
        .then(() => { 
            // this.props.allCreativeFunc("Creative has been updated successfully") 
            this.onCancel(true);
            this.props.setSpinnerCount(0);
        })
        .catch((err) => {
                AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updateCreativeValues(updatedSelectedRowData), title: 'Unable to update the creative', bodyMsgArr: [] }]); 
                this.props.setSpinnerCount(0);
            })
            .finally(() => {
                this.props.setSpinnerCount(0);
            });
    }
    updateCampaignValues = (updatedSelectedRowData) => {
        if(this.props.isCreatingChildCampaign){
             this.onCancel(updatedSelectedRowData);
             return;
        }
        this.props.setSpinnerCount(1);
        let payload = {
            campaignTaxonomy: this.state.isOverride ? this.state.taxonomyPrevName : updatedSelectedRowData.campaign_taxonomy,
            campaignTaxonomyDisplay: this.state.isOverride ? this.state.taxonomyPrevName?.split(':|')[0] : updatedSelectedRowData.campaign_taxonomy_display,
            taxonomySchema: updatedSelectedRowData.taxonomy_schema,
            campaignStartDate: this.state.campaignObj?.startDate,
            campaignEndDate: this.state.campaignObj?.endDate,
            taxonomy: this.state.isOverride ? null : updatedSelectedRowData.taxonomy,
            taxonomy_client_id: this.state.isOverride ? this.state.taxonomySchemaArray?.clientid : updatedSelectedRowData?.taxonomy_client_id,
            taxonomy_schema_id: this.state.isOverride ? this.state.taxonomySchemaArray?.id : updatedSelectedRowData?.taxonomy_schema_id
        };
        if(this.props.isCreatingChildCampaign){
             this.onCancel(updatedSelectedRowData);
            this.props.setSpinnerCount(0);
        }
        let campaignId = encodeURIComponent(this.state.campaignObj.id);
        MediaOpsService.updateCampaign(payload, campaignId, this.props?.versionOneApi).then(
            (response) => {
                trackEvent(`Campaign Taxonomy is updated.`, { access_from: 'Campaign Details Page', campaignId });
                this.onCancel(updatedSelectedRowData);
                this.props.setSpinnerCount(0);
            },
            (error) => {
                trackEvent(`Campaign Taxonomy update is failed.`, { access_from: 'Campaign Details Page', campaignId, error: error?.response?.data });
                AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updateCampaignValues(updatedSelectedRowData), title: 'Unable to update the campaign', bodyMsgArr: [] }]);
                this.props.setSpinnerCount(0);
            })
    }
    /**
     * Method to update the supplier for child placements on inline edit by calling the updatePlacement API and handling the response.
     * @param {array} childPlacmentsArray - The array of child placements.
     * @param {object} selectedValueObj - The selected dropdown value object.
     * @returns {void}
     */
    updateChildValues = (fieldName,taxonomyType,selectedDDValue) => {
        let childPlacmentsArray = this.state.childPlacmentsArray;
        let taxonomySchemaList = this.state.taxonomySchemaList;
        childPlacmentsArray.forEach((childPlacement, index) => {
            if(!childPlacement.override_taxonomy){
                let taxonomySchemaArray = taxonomySchemaList[index];
                let { schemaArr, editFormData }  = PlacementDetailsTableService.getFormEditData(taxonomySchemaArray?.fields,childPlacement,taxonomyType);
                let isNameAndSchemaFieldMatch = Object.keys(editFormData).length === taxonomySchemaArray.length ? true : false;
                    
                if(isNameAndSchemaFieldMatch){
                    childPlacement = this.updateNameState(null, fieldName, childPlacement,taxonomyType,placementDisplay,taxonomySchemaArray,selectedDDValue,editFormData);
                }
            }
        });
        this.setState({childPlacmentsArray});
    };

    onCancel = (isPlacementSaved=false) => {
        this.props.onInlineModalClose(isPlacementSaved)
        this.setState({ selecedData: {}, selectedButtonDisabled: true });
    }

    /**
     * Validates if a field value contains spaces when spaces are not allowed
     * @param {string} value - The value to validate
     * @param {string} fieldName - The name of the field
     * @param {object} placement - The placement object
     * @returns {boolean} - Returns true if validation passes, false if spaces are not allowed
     */
    validateFieldSpaces = (value, fieldName, placement) => {
        if (!value || typeof value !== 'string') {
            return true;
        }
        
        // Get taxonomy data for field configuration
        let taxonomyData  = this.state.taxonomySchemaArray
        
        if (taxonomyData?.fields) {
            const field = taxonomyData.fields.find(f => f.name === fieldName || f.field_name === fieldName);
            if (field?.field_type === 2 && field?.allowed_space === false && value.includes(' ')) {
                return false;
            }
        }
        
        return true;
    }
    /**
     * Set the taxonomy schema to filter out hidden fields and
     * calls the inline update API with the selected row data.
    */
    callInlineUpdate = ()=>{
        let selectedRowData = {...this.state.selectedRowData};
        let taxonomySchemaArray = this.state.taxonomySchemaArray?.fields;
        selectedRowData[this.state.taxonomyKeys?.schema] = taxonomySchemaArray?.filter(val=>!val?.hidden).map(val=>val?.name || val?.alias).join('|');

        if(this.state.taxonomyKeys?.taxonomyName === 'campaign_taxonomy'){
            this.updateCampaignValues(selectedRowData);
        }else if(this.state.taxonomyKeys?.taxonomyName === 'creative_name'){
            this.updateCreativeValues(selectedRowData);
        }else{
            this.updatePlacementValues(selectedRowData);
        }
    }

    // Handles changes to the override input field.
    onOverrideChange = (e) => {
        this.setState({ taxonomyPrevName: e.target.value + ":|" + this.state.syntheticId, isValueChanged: true })
    }

    // Cancels the override and resets the state.
    cancelOverride = () => {
        this.setState({ isOverride: false}, () => {
            this.setTaxonomyJson(this.state.editFormData);
        });
    }

    // Overrides the taxonomy name.
    overrideTaxonomy = () => {
        this.setState({ isOverride: true }, () => {
            this.setTaxonomyJson(this.state.editFormData);
        });
    }

    render() {
        return  (
                <>
                    {this.state.displayInlineEditModal && 
                        <div part='placementName' key="placement-inline-edit">
                            <div className='placement-inline-modal modal is-active'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <div className='modal-header-title'>
                                            Edit Taxonomy
                                        </div>
                                        <hr className='modal-header-divider' />
                                    </div>
                                    <div className="modal-middle-section">
                                        <div className="info-text-label">
                                            <span className="info-text">
                                                To edit the taxonomy string, click each section of text below and choose an option from the dropdown.
                                                <OmniTooltipNextComponent>
                                                    <omni-icon slot="invoker" class="is-size-4" icon-id="omni:informative:info"></omni-icon>
                                                    <div slot="content">Note: Fields in (parenthesis) don’t show  in the actual taxonomy naming string.</div>
                                                </OmniTooltipNextComponent>
                                            </span>
                                        </div>
                                        <div className='modal-inline-edit-section' id="placement-inline-edit">
                                            <div className="inline-names">
                                                {this.state.taxonomyKeys?.taxonomyName !== 'parameter_code' && 
                                                (this.state.isOverride ? 
                                                    <>
                                                        <textarea id="override-input-field" type="text" rows="2" className="override-input" value={this.state.taxonomyPrevName?.split(':|')[0]} onChange={(e) => this.onOverrideChange(e)}></textarea>
                                                        <button onClick={this.cancelOverride} slot="invoker" aria-haspopup="true" className="icon">
                                                            <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:reset" />
                                                        </button>
                                                    </> :
                                                    <>
                                                        {this.getTaxonomyName(this.state.taxonomyKeys.taxonomyName)}
                                                        <button onClick={this.overrideTaxonomy} slot="invoker" aria-haspopup="true" className="icon">
                                                            <OmniIconComponent className="is-size-2 header-icon" icon-id="omni:interactive:edit" />
                                                        </button>
                                                    </>
                                                )}
                                                {this.state.taxonomyKeys?.taxonomyName === 'parameter_code' && this.getTaxonomyName(this.state.taxonomyKeys.taxonomyName)}
                                            </div>
                                            {this.state.taxonomyKeys.taxonomyName !== 'parameter_code' && <div className="sythetic-id placement-name">
                                                <span className="text-value">
                                                    {this.state?.syntheticId}
                                                </span> 
                                            </div>}
                                        </div>
                                        <div className="info-section">
                                            {this.state.isOverride ? <span>Manually editing this placement name may not be taxonomy compliant.</span> : <span>Please review and update the fields in red (If any).</span>}
                                        </div>
                                        <div className='taxonomy-preview'>
                                            <span className="taxonomy-label">Taxonomy preview:</span>
                                            <span className="taxonomy-value">
                                                {this.state?.taxonomyPrevName ? this.state.taxonomyPrevName : ''}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='modal-footer'>
                                        <div className='modal-button-group'>
                                            <div className="footer-left-side">
                                                <span>* Optional taxonomy fields</span>
                                            </div>
                                            <div className="footer-right-side">
                                                <button className='tertiary' onClick={(event) => this.onCancel()}>
                                                    Cancel
                                                </button>
                                                <button disabled={this.state.isValueChanged?null:true} onClick={() => this.state.isValueChanged ? this.callInlineUpdate() : ''}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </>
                )
    }
}